import { render } from "./Profile.vue?vue&type=template&id=25318a1c&scoped=true"
import script from "./Profile.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Profile.vue?vue&type=script&charset=utf-8&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=25318a1c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25318a1c"]])

export default __exports__